<!-- Component that implements a list of documents -->
<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card>
          <basic-toolbar :title="'Ocorrências do integrante ' + this.integrante.nome"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-data-table
          :headers="headers"
          :items="listaOcorrenciasIntegrante"
          :search="search"
          :no-data-text="'Esse integrante não possui ocorrências'"
          must-sort
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items-per-page="itemsPerPage"
          :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
          >
            <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
              Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaOcorrenciasIntegrante.length }} ocorrências
            </template>
            <template v-slot:item.dtOcorrencia="props">{{dates.format(props.item.dtOcorrencia)}}</template>
            <template v-slot:item.dataInicial="props">{{dates.format(props.item.dataInicial)}}</template>
            <template v-slot:item.dataFinal="props">{{dates.format(props.item.dataFinal)}}</template>
            <template v-slot:item.assessor="props">{{formatAssessor.format(props.item.assessor, props.item.funcao.item)}}</template>
          </v-data-table>

          <br>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="primary" text @click="$router.go(-1)">Voltar</v-btn>
          </v-card-actions>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import formatAssessor from '@/utils/assessor'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    integrante: {},
    listaOcorrenciasIntegrante: [],
    dates: dates,
    formatAssessor: formatAssessor,
    search: null,
    sortBy: 'dtCriacao',
    sortDesc: true,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Data', align: 'center', value: 'dtOcorrencia' },
      { text: 'Usuário', align: 'center', value: 'loginResponsavel' },
      { text: 'Data Inicial', align: 'center', value: 'dataInicial' },
      { text: 'Data Final', align: 'center', value: 'dataFinal' },
      { text: 'Função', align: 'center', value: 'funcao.descricao' },
      { text: 'Assessor', align: 'center', value: 'assessor' },
      { text: 'Titulação', align: 'center', value: 'titulacao.descricao' },
      { text: 'Carga Horária', align: 'center', value: 'cargaHoraria' },
      { text: 'Situação', align: 'center', value: 'situacao' },
      { text: 'Observações', align: 'center', value: 'obsParticipante' }
    ]
  }),
  props: ['items', 'idProjeto', 'idParticipante'],
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
    projetos.getIntegrante(this.idProjeto, this.idParticipante)
    .then(response => {
      this.integrante = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
    })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ocorrências.' })
    projetos.getOcorrenciasIntegrante(this.idProjeto, this.idParticipante)
    .then(response => {
      this.listaOcorrenciasIntegrante = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ocorrências.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// ocorrencias-integrante.vue?006a8cf9